import {Injectable} from '@angular/core';
import {environment} from '../../../environments/environment';
import {Endpoints, GeoservicesEndpoints} from '../../enums/endpoints.enum';

@Injectable({
  providedIn: 'root',
})
export class ApiUrlService {
  constructor() {}

  getBaseUrl() {
    const baseUrl = environment.baseurl;

    return baseUrl;
  }

  getUrl(endpoint: Endpoints | GeoservicesEndpoints, baseUrl = this.getBaseUrl()): string {
    return `${baseUrl}${endpoint}`;
  }
}
